import { FC } from "react";

import { BatchPrognosis } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/infrastructureEventModal/BatchPrognosis";
import { TrainInfoBatchFormProps } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/TrainInfoBatchForm";
import { BatchTrainFormFieldWithCustomInput } from "features/CenterContent/shared/operationalInformation/components/BatchTrainFormFieldWithCustomInput";
import { filterOpInfoTypesTrain } from "features/CenterContent/shared/operationalInformation/utils";
import { Stack } from "shared/components/Spor";
import { useCountryCodeForDropsRole } from "shared/hooks/useCountryCodeForDropsRole";
import { countryCode as countryCodeEnum } from "shared/types/countryCode";

export const FormInputs: FC<TrainInfoBatchFormProps> = ({
  opInfoTypes,
  activeTrainSeriesKey,
  groupsInSeries,
  lockEventType = false,
}) => {
  const { events, reasons, actions } = filterOpInfoTypesTrain(opInfoTypes);
  const countryCode = useCountryCodeForDropsRole();
  return (
    <Stack gap="6px">
      <BatchTrainFormFieldWithCustomInput
        pathPrefix={`${activeTrainSeriesKey}`}
        numberOfGroups={groupsInSeries}
        items={events}
        formFieldType="event"
        disabled={lockEventType}
      />
      <BatchTrainFormFieldWithCustomInput
        pathPrefix={`${activeTrainSeriesKey}`}
        numberOfGroups={groupsInSeries}
        items={reasons}
        formFieldType="reason"
      />
      <BatchTrainFormFieldWithCustomInput
        pathPrefix={`${activeTrainSeriesKey}`}
        numberOfGroups={groupsInSeries}
        items={actions}
        formFieldType="action"
      />
      {countryCode === countryCodeEnum.enum.SE && (
        <BatchPrognosis
          pathPrefix={`${activeTrainSeriesKey}`}
          numberOfGroups={groupsInSeries}
        />
      )}
    </Stack>
  );
};
